/**
 * 發票資訊處理模組 v2.0
 * 負責處理統一編號和公司抬頭的輸入及儲存
 * 
 * 改進重點：
 * 1. 使用 hidden inputs 作為備份機制
 * 2. 改用原生表單提交，避免 setTimeout + click() 的時間差問題
 * 3. 增加 loading 狀態防止重複點擊
 * 4. 強化驗證和同步機制
 */

document.addEventListener('DOMContentLoaded', function() {
  const companyInput = document.getElementById('cart-note-company');
  const taxIdInput = document.getElementById('cart-note-tax');
  const invoicePersonal = document.getElementById('invoice-personal');
  const invoiceCompany = document.getElementById('invoice-company');
  const companyFields = document.getElementById('company-invoice-fields');
  const checkoutButton = document.querySelector('.sp-proceed-to-checkout button[name="checkout"]');
  const forceCompanyInvoice = document.getElementById('force-company-invoice');
  const cartForm = document.querySelector('form.sp-cart-form');
  
  // Hidden inputs 參照
  const hiddenInvoiceType = document.getElementById('hidden-invoice-type');
  const hiddenCompanyName = document.getElementById('hidden-company-name');
  const hiddenTaxId = document.getElementById('hidden-tax-id');

  if (!companyInput || !taxIdInput || !invoicePersonal || !invoiceCompany || !companyFields || !checkoutButton) return;
  
  // Loading 狀態標記
  let isProcessing = false;
  
  // 檢查是否需要強制切換到公司發票
  const shouldForceCompanyInvoice = forceCompanyInvoice && forceCompanyInvoice.value === 'true';
  
  // 如果設置了強制公司發票標誌，或者第一次訪問頁面，則重置為公司發票
  if (shouldForceCompanyInvoice || !localStorage.getItem('invoiceTypeSet')) {
    console.log('強制重置為公司發票');
    invoiceCompany.checked = true;
    invoicePersonal.checked = false;
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          invoice_type: 'company'
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('已強制重置為公司發票:', data.attributes);
      localStorage.setItem('invoiceTypeSet', 'true');
      companyFields.style.opacity = '1';
      companyFields.style.pointerEvents = 'auto';
      syncHiddenInputs();
    })
    .catch(error => {
      console.error('重置發票類型失敗:', error);
    });
  }

  // 獲取當前的發票類型
  let currentInvoiceType = '';
  if (invoicePersonal.checked) {
    currentInvoiceType = 'personal';
  } else if (invoiceCompany.checked) {
    currentInvoiceType = 'company';
  } else {
    currentInvoiceType = 'company';
    invoiceCompany.checked = true;
  }

  // 預設值強制設為公司發票
  if (currentInvoiceType !== 'personal') {
    console.log('初始化預設為公司發票');
    invoiceCompany.checked = true;
    invoicePersonal.checked = false;
  }

  // 初始化發票類型顯示狀態
  if (invoicePersonal.checked) {
    companyFields.style.opacity = '0.5';
    companyFields.style.pointerEvents = 'none';
  } else {
    companyFields.style.opacity = '1';
    companyFields.style.pointerEvents = 'auto';
  }
  
  // 初始化時同步 hidden inputs
  syncHiddenInputs();
  
  // 初始化時更新購物車屬性
  setTimeout(function() {
    const shouldClearFields = invoicePersonal.checked;
    updateInvoiceInfo(shouldClearFields);
  }, 0);

  /**
   * 同步 hidden inputs 的值
   * 這是雙重保險機制，確保表單提交時一定帶有正確的發票資訊
   */
  function syncHiddenInputs() {
    if (!hiddenInvoiceType || !hiddenCompanyName || !hiddenTaxId) return;
    
    const invoiceType = invoicePersonal.checked ? 'personal' : 'company';
    const companyName = invoicePersonal.checked ? '' : companyInput.value.trim();
    const taxId = invoicePersonal.checked ? '' : taxIdInput.value.trim();
    
    hiddenInvoiceType.value = invoiceType;
    hiddenCompanyName.value = companyName;
    hiddenTaxId.value = taxId;
    
    console.log('Hidden inputs 已同步:', { invoiceType, companyName, taxId });
  }

  // 切換發票類型
  function toggleInvoiceType() {
    if (invoicePersonal.checked) {
      companyFields.style.opacity = '0.5';
      companyFields.style.pointerEvents = 'none';
      updateInvoiceInfo(true);
      localStorage.setItem('userSelectedInvoiceType', 'personal');
    } else {
      companyFields.style.opacity = '1';
      companyFields.style.pointerEvents = 'auto';
      updateInvoiceInfo();
      localStorage.setItem('userSelectedInvoiceType', 'company');
    }
    syncHiddenInputs();
  }

  invoicePersonal.addEventListener('change', toggleInvoiceType);
  invoiceCompany.addEventListener('change', toggleInvoiceType);

  // 防抖動函式
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // 更新發票資訊
  const updateInvoiceInfo = debounce(async function(clearFields = false) {
    try {
      const company = clearFields ? '' : companyInput.value.trim();
      const taxId = clearFields ? '' : taxIdInput.value.trim();
      const invoiceType = invoicePersonal.checked ? 'personal' : 'company';
      
      // 同步 hidden inputs
      syncHiddenInputs();
      
      // 如果是公司發票且資訊不完整，只更新發票類型
      if (invoiceType === 'company' && !clearFields) {
        if (!company || !taxId) {
          console.log('公司發票資訊不完整，等待使用者完成輸入');
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                invoice_type: invoiceType
              }
            })
          });
          return;
        }
      }
      
      console.log('更新購物車屬性:', { company_name: company || '', tax_id: taxId || '', invoice_type: invoiceType });

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            company_name: company || '',
            tax_id: taxId || '',
            invoice_type: invoiceType
          }
        })
      });

      if (!response.ok) {
        throw new Error('更新失敗');
      }
      
      const data = await response.json();
      console.log('購物車更新成功:', data.attributes);
      
      if (clearFields) {
        companyInput.value = '';
        taxIdInput.value = '';
        syncHiddenInputs();
      }
    } catch (error) {
      console.error('發票資訊更新錯誤:', error);
    }
  }, 300);

  // 輸入事件監聽
  companyInput.addEventListener('change', () => {
    updateInvoiceInfo();
    syncHiddenInputs();
  });
  
  companyInput.addEventListener('input', debounce(() => {
    syncHiddenInputs();
  }, 100));

  taxIdInput.addEventListener('change', (event) => {
    const value = event.target.value.trim();
    
    document.querySelectorAll('.error-message').forEach(el => el.remove());
    document.querySelectorAll('.invoice-info__input.error').forEach(el => el.classList.remove('error'));
    
    if (value && !/^\d{8}$/.test(value)) {
      taxIdInput.classList.add('error');
      const errorMsg = document.createElement('div');
      errorMsg.className = 'error-message';
      errorMsg.textContent = '統一編號必須為8位數字';
      taxIdInput.parentNode.appendChild(errorMsg);
    }
    
    updateInvoiceInfo();
    syncHiddenInputs();
  });
  
  taxIdInput.addEventListener('input', (event) => {
    const value = event.target.value.trim();
    
    document.querySelectorAll('.error-message').forEach(el => el.remove());
    document.querySelectorAll('.invoice-info__input.error').forEach(el => el.classList.remove('error'));
    
    if (value && !/^\d{8}$/.test(value)) {
      taxIdInput.classList.add('error');
      const errorMsg = document.createElement('div');
      errorMsg.className = 'error-message';
      errorMsg.textContent = '統一編號必須為8位數字';
      taxIdInput.parentNode.appendChild(errorMsg);
    }
    
    syncHiddenInputs();
  });

  // 驗證公司發票資訊
  function validateCompanyInvoice() {
    if (invoiceCompany.checked) {
      const company = companyInput.value.trim();
      const taxId = taxIdInput.value.trim();
      
      document.querySelectorAll('.error-message').forEach(el => el.remove());
      document.querySelectorAll('.invoice-info__input.error').forEach(el => el.classList.remove('error'));
      
      let hasError = false;
      
      if (!company) {
        companyInput.classList.add('error');
        const errorMsg = document.createElement('div');
        errorMsg.className = 'error-message';
        errorMsg.textContent = '請輸入公司抬頭';
        companyInput.parentNode.appendChild(errorMsg);
        hasError = true;
      }
      
      if (!taxId) {
        taxIdInput.classList.add('error');
        const errorMsg = document.createElement('div');
        errorMsg.className = 'error-message';
        errorMsg.textContent = '請輸入統一編號';
        taxIdInput.parentNode.appendChild(errorMsg);
        hasError = true;
      } else if (!/^\d{8}$/.test(taxId)) {
        taxIdInput.classList.add('error');
        const errorMsg = document.createElement('div');
        errorMsg.className = 'error-message';
        errorMsg.textContent = '統一編號必須為8位數字';
        taxIdInput.parentNode.appendChild(errorMsg);
        hasError = true;
      }
      
      if (hasError) {
        document.querySelector('.invoice-info').scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      
      return !hasError;
    }
    
    return true;
  }

  /**
   * 設置按鈕 Loading 狀態
   */
  function setButtonLoading(loading) {
    if (loading) {
      isProcessing = true;
      checkoutButton.disabled = true;
      checkoutButton.dataset.originalText = checkoutButton.innerHTML;
      checkoutButton.innerHTML = '<span class="spinner"></span> 處理中...';
      checkoutButton.style.opacity = '0.7';
    } else {
      isProcessing = false;
      checkoutButton.disabled = false;
      if (checkoutButton.dataset.originalText) {
        checkoutButton.innerHTML = checkoutButton.dataset.originalText;
      }
      checkoutButton.style.opacity = '1';
    }
  }

  /**
   * 結帳驗證處理（改進版）
   * 使用原生表單提交，避免 setTimeout + click() 的問題
   */
  async function checkoutValidation(event) {
    console.log('結帳按鈕點擊事件觸發，發票類型:', invoicePersonal.checked ? 'personal' : 'company');
    
    // 防止重複點擊
    if (isProcessing) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return false;
    }
    
    // 先阻止預設行為
    event.preventDefault();
    event.stopImmediatePropagation();
    
    // 驗證
    const isValid = validateCompanyInvoice();
    
    if (!isValid) {
      console.log('驗證未通過，阻止提交');
      return false;
    }
    
    // 設置 loading 狀態
    setButtonLoading(true);
    
    // 同步 hidden inputs
    syncHiddenInputs();
    
    // 如果是公司發票，強制同步購物車屬性
    if (invoiceCompany.checked) {
      try {
        const company = companyInput.value.trim();
        const taxId = taxIdInput.value.trim();
        
        console.log('強制更新購物車屬性:', { company_name: company, tax_id: taxId, invoice_type: 'company' });
        
        // 強制同步購物車屬性
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              company_name: company,
              tax_id: taxId,
              invoice_type: 'company'
            }
          })
        });
        
        if (!updateResponse.ok) {
          throw new Error('更新購物車失敗');
        }
        
        const updateData = await updateResponse.json();
        console.log('購物車更新回應:', updateData.attributes);
        
        // 驗證購物車屬性是否正確儲存
        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();
        
        console.log('購物車驗證:', cartData.attributes);
        
        // 嚴格驗證：確保兩個欄位都有值
        if (!cartData.attributes || !cartData.attributes.company_name || !cartData.attributes.tax_id) {
          console.error('購物車屬性不完整:', cartData.attributes);
          setButtonLoading(false);
          alert('發票資訊儲存失敗，請重新輸入並重試');
          return false;
        }
        
        // 額外驗證：確保儲存的值與輸入的值一致
        if (cartData.attributes.company_name !== company || cartData.attributes.tax_id !== taxId) {
          console.error('購物車屬性值不匹配:', {
            expected: { company, taxId },
            actual: { company_name: cartData.attributes.company_name, tax_id: cartData.attributes.tax_id }
          });
          
          // 重試一次
          console.log('嘗試重新同步...');
          const retryResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: {
                company_name: company,
                tax_id: taxId,
                invoice_type: 'company'
              }
            })
          });
          
          if (!retryResponse.ok) {
            setButtonLoading(false);
            alert('發票資訊儲存失敗，請重試');
            return false;
          }
          
          // 再次驗證
          const retryCartResponse = await fetch('/cart.js');
          const retryCartData = await retryCartResponse.json();
          
          if (!retryCartData.attributes || retryCartData.attributes.company_name !== company || retryCartData.attributes.tax_id !== taxId) {
            setButtonLoading(false);
            alert('發票資訊儲存失敗，請清除瀏覽器快取後重試，或聯繫客服');
            return false;
          }
        }
        
        console.log('✓ 購物車屬性已確認完整且正確');
        
      } catch (error) {
        console.error('同步購物車屬性失敗:', error);
        setButtonLoading(false);
        alert('發票資訊儲存失敗，請重試');
        return false;
      }
    }
    
    console.log('驗證通過，準備提交表單');
    
    // 最後再同步一次 hidden inputs
    syncHiddenInputs();
    
    // 使用原生方式提交表單到結帳頁面
    if (cartForm) {
      // 創建一個臨時的 submit input 來觸發結帳
      const submitInput = document.createElement('input');
      submitInput.type = 'hidden';
      submitInput.name = 'checkout';
      submitInput.value = '';
      cartForm.appendChild(submitInput);
      
      // 使用 requestAnimationFrame 確保 DOM 更新完成後提交
      requestAnimationFrame(() => {
        cartForm.submit();
      });
    }
  }

  // 綁定結帳按鈕驗證
  checkoutButton.addEventListener('click', checkoutValidation, true);
  
  // 表單提交驗證
  if (cartForm) {
    cartForm.addEventListener('submit', function(event) {
      // 如果正在處理中（已經通過驗證），允許提交
      if (isProcessing) {
        return true;
      }
      
      // 檢查是否是結帳提交
      const submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') {
        // 這會被 checkoutValidation 處理
        return true;
      }
    }, true);
  }

  // 其他結帳按鈕也綁定驗證
  document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function(btn) {
    if (btn !== checkoutButton) {
      btn.addEventListener('click', checkoutValidation, true);
    }
  });

  // 頁面載入完成後確認狀態
  window.addEventListener('load', function() {
    setTimeout(function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          console.log('載入完成後獲取購物車數據:', data.attributes);
          
          const userSelectedType = localStorage.getItem('userSelectedInvoiceType');
          
          if (userSelectedType) {
            console.log('用戶明確選擇的發票類型:', userSelectedType);
            if (userSelectedType === 'personal') {
              if (!invoicePersonal.checked) {
                invoicePersonal.checked = true;
                invoiceCompany.checked = false;
                toggleInvoiceType();
              }
            } else {
              if (!invoiceCompany.checked) {
                invoiceCompany.checked = true;
                invoicePersonal.checked = false;
                toggleInvoiceType();
              }
            }
          } else if (data.attributes && data.attributes.invoice_type) {
            if (data.attributes.invoice_type === 'personal') {
              if (!invoicePersonal.checked) {
                console.log('從購物車屬性獲取，設置為個人發票');
                invoicePersonal.checked = true;
                invoiceCompany.checked = false;
                toggleInvoiceType();
              }
            } else {
              if (!invoiceCompany.checked) {
                console.log('從購物車屬性獲取，設置為公司發票');
                invoiceCompany.checked = true;
                invoicePersonal.checked = false;
                toggleInvoiceType();
              }
            }
          } else {
            console.log('沒有找到發票類型設定，重設為公司發票');
            invoiceCompany.checked = true;
            invoicePersonal.checked = false;
            toggleInvoiceType();
            updateInvoiceInfo();
          }
          
          // 確保 hidden inputs 同步
          syncHiddenInputs();
        })
        .catch(error => {
          console.error('獲取購物車資訊失敗:', error);
        });
    }, 0);
  });
});
